import React from 'react';
import { Divider } from 'semantic-ui-react'

const VerOrdenCompraFin1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel, handleClickSel1}) => {
  const a3545 = autorizacUA.findIndex( autorizac => autorizac === "3545" );
  // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a3545!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit red icon"></i>
        Modificar
      </button>
      }
      {/* {a3545!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel1(ev)}>
        <i className="large print red icon"></i>
        Generar PDF de remisión
      </button>
      } */}
      {a3545!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate red icon"></i> 
        Cancelar orden de compra
      </button>
      }
      <Divider inverted /> 
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
      <div className="column" style={{width: '100%'}}>
        <p style={{color: 'black', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0.8em 0.8em 0.8em', alignContent: 'center'}}>
          Para poder cerrar la orden es necesario que carguen el archivo de informe: Remisión consolidada (Despachos), Informe gerencial (Inf. de laboratorio), Informe de operación (In house), etc.
        </p>                
      </div>
    </div>
  )
};

export default VerOrdenCompraFin1
